import { useGlobalAlert } from "@/States/globalAlert";
import { trpc } from "@/Utils/trpc";

type Options = {
  onSuccessFunc?: () => void;
};

export const useEmailJob = (options?: Options) => {
  const { setGlobalAlert } = useGlobalAlert();

  const { mutateAsync: addEmailJob, isPending: isAddingEmailJob } =
    trpc.config.createEmailJob.useMutation({
      onSuccess: () => {
        options?.onSuccessFunc?.();
        setGlobalAlert({
          type: "success",
          message: "systemMessages:recipientSaved",
        });
      },
      onError: (error) => {
        console.log(error);
        setGlobalAlert({
          type: "error",
          message: error.message,
        });
      },
    });

  const { mutateAsync: updateEmailJob, isPending: isUpdatingEmailJob } =
    trpc.config.updateEmailJob.useMutation({
      onSuccess: () => {
        options?.onSuccessFunc?.();
        setGlobalAlert({
          type: "success",
          message: "systemMessages:changesSaved",
        });
      },
      onError: (error) => {
        setGlobalAlert({
          type: "error",
          message: error.message,
        });
      },
    });

  const { mutateAsync: deleteEmailJob, isPending: isDeletingEmailJob } =
    trpc.config.deleteEmailJob.useMutation({
      onSuccess: () => {
        options?.onSuccessFunc?.();
        setGlobalAlert({
          type: "success",
          message: "systemMessages:recipientDeleted",
        });
      },
      onError: (error) => {
        setGlobalAlert({
          type: "error",
          message: error.message,
        });
      },
    });

  return {
    addEmailJob,
    isAddingEmailJob,
    updateEmailJob,
    isUpdatingEmailJob,
    deleteEmailJob,
    isDeletingEmailJob,
  };
};
